import React, { useState, useEffect } from "react";
import clsx from "clsx";
import styles from "./STRadioGroup.module.css";
import { Icons } from "@/const/icons";

export const STRadioGroup = ({
  label,
  options = [],
  name,
  value,
  onChange,
  error,
  required,
  className,
  optionClass,
}) => {
  const [internalValue, setInternalValue] = useState(value || "");

  useEffect(() => {
    if (value !== undefined) {
      setInternalValue(value);
    }
  }, [value]);

  const handleChange = (val) => {
    setInternalValue(val);
    if (onChange) onChange(val);
  };

  return (
    <div className={className}>
      {label && (
        <label className={clsx(styles.label)}>
          {label}
        </label>
      )}
      <div className={styles.optionsWrapper}>
        {options.map((opt) => (
          <label
            key={opt.value}
            className={clsx(
              styles.optionLabel,
              optionClass,
              internalValue === opt.value && styles.activeOption,
              "d-flex align-items-center justify-content-between gap-xs cursor-pointer bg-clr-white transition-smooth"
            )}
          >
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={internalValue === opt.value}
              onChange={() => handleChange(opt.value)}
              className={styles.hiddenInput}
            />
            <span className={styles.optionText}>{opt.label}</span>
            <span
              className={clsx(
                styles.iconWrapper,
                internalValue === opt.value && styles.activeIcon
              )}
            >
              {internalValue === opt.value ? Icons.checkCircleIcon : ""}
            </span>
          </label>
        ))}
      </div>
      {error && <p className={clsx(styles.errorText, "text-danger")}>{error}</p>}
    </div>
  );
};
